import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Header from './Header.js';
import { DataContext } from './DataContextProvider.js';
import DataTable from './DataTable.js';

export default function Lists() {
  const dataContext = React.useContext(DataContext);

  const addList = async () => {
    const listName = document.getElementById('listName');
    if (!listName.value) {
      alert('Enter a list name');
      return;
    }
    await fetch('/api/lists', {
      method: 'POST',
      body: JSON.stringify({name: listName.value}),
      headers: {'Content-Type': 'application/json'},
    });
    listName.value = '';
    dataContext.forceUpdate();
  };

  return (
    <>
      <Header title="Lists" location="/lists">
        <Form.Control id="listName" type="text" placeholder="List name" />
        <Button variant="secondary" onClick={addList}>New</Button>
      </Header>
      <DataTable item="lists" title="Lists" />
    </>
  );
}
